import type { TrainingLessonSpecific } from './trainingLessonUi';

export const highPriest1KeysEn: TrainingLessonSpecific = {
  intro:
    'A high priest understands keys, authority, and power. Keys do not make you holier; they make you more responsible. Priesthood without charity becomes noise; with charity, it becomes real power.',
  objectives: [
    'Understand the purpose of the office of high priest in the Melchizedek Priesthood.',
    'Differentiate keys vs authority vs power.',
    'Understand how priesthood is exercised to bless, not to control.',
    'Learn to support and sustain leaders with loyalty and order.',
    'Define habits of dignity and service that strengthen the Lord’s trust.',
  ],
  briefHeading: 'Keys and presidency in brief',
  briefBody:
    'Keys order the work; power flows according to righteousness. Sustaining leaders is part of the priesthood covenant.',
  scriptures: [
    { ref: 'D&C 107:8–9', text: '…the Melchizedek Priesthood holds the keys of all the spiritual blessings of the church…' },
    { ref: 'D&C 121:41–42', text: '…by persuasion, by long-suffering, by gentleness and meekness, and by love unfeigned…' },
    { ref: 'D&C 84:33–39', text: '…the oath and covenant of the priesthood…' },
    { ref: 'Hebrews 5:4', text: '…no man taketh this honour unto himself, but he that is called of God…' },
    { ref: 'D&C 20:60', text: '…every elder, priest, teacher, or deacon is to be ordained according to the gifts and callings of God unto him…' },
  ],
  didYouKnow: [
    'Keys do not make you “holier”; they make you more responsible.',
    'Priesthood without charity becomes “noise.” With charity, it becomes real power.',
  ],
  practiceItems: [
    'Write one sentence on the difference between keys / authority / power',
    'Identify who holds keys in your ward and what they preside over',
    'Practice sustaining: do one concrete act to support a leader without seeking recognition',
    'Review Sunday conduct: what habit should I change to be more dignified and reverent?',
    'Choose one way to improve your speech (less criticism, more edification)',
    'Do a “D&C 121 check”: am I persuading or pushing?',
  ],
  reflectionQuestions: [
    'Where do I confuse authority with control?',
    'What habits should I correct to be spiritually trustworthy?',
    'How can I sustain my leaders better this week?',
  ],
  actionText:
    'Sustain with deeds: pick one leader and support them with a concrete action (service, logistics, encouragement, presence).',
};
